import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter , BrowserRouter } from 'react-router-dom';
import NavigationProvider from './Components/contentApi/NavigationProvider';

export const BaseUrl = "https://api.pharmatuition.in/api/";
export const ImageUrl="https://api.pharmatuition.in/";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <NavigationProvider>
       <HashRouter>
        <App />
       </HashRouter>
    </NavigationProvider>
  </React.StrictMode>
);

reportWebVitals();
